<template>
  <div
    id="app"
  >
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title = `${to?.meta?.title || 'STATECS'} | STATECS` || 'STATECS';
      },
    },
  },
};
</script>

<style lang="scss">
@import '~filepond/dist/filepond.min.css';
@import "styles.scss";
</style>
